<ng-container *transloco="let tr; prefix: 'webkassaCashboxes'; scope: 'webkassa-cashboxes'">
  <nz-affix [nzOffsetTop]="0">
    <hx-breadcrumbs></hx-breadcrumbs>
    <nz-page-header nzBackIcon [nzGhost]="false">
      <nz-page-header-title>{{ tr('title') }}</nz-page-header-title>
    </nz-page-header>
  </nz-affix>

  <nz-skeleton [nzActive]="true" [nzLoading]="isLoading.model">
    <form nz-form class="hx-form" [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()">
      <div nz-row [nzGutter]="8">
        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{ tr('form.name') }}</nz-form-label>
            <nz-form-control>
              <input nz-input formControlName="name"/>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{ tr('form.enabled') }}</nz-form-label>
            <nz-form-control>
              <nz-radio-group formControlName="enabled">
                <label nz-radio [nzValue]="true">{{ 'yes' | transloco }}</label>
                <label nz-radio [nzValue]="false">{{ 'no' | transloco }}</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{ tr('form.offline') }}</nz-form-label>
            <nz-form-control>
              <nz-radio-group formControlName="offline">
                <label nz-radio [nzValue]="true">{{ 'yes' | transloco }}</label>
                <label nz-radio [nzValue]="false">{{ 'no' | transloco }}</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row [nzGutter]="8">
        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{ tr('form.uniqueNumber') }}</nz-form-label>
            <nz-form-control>
              <input nz-input formControlName="uniqueNumber"/>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{ tr('form.registrationNumber') }}</nz-form-label>
            <nz-form-control>
              <input nz-input formControlName="registrationNumber"/>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{ tr('form.identificationNumber') }}</nz-form-label>
            <nz-form-control>
              <input nz-input formControlName="identificationNumber"/>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row [nzGutter]="8">
        <div nz-col class="hx-col-3">
          <nz-form-item>
            <nz-form-label>{{ tr('form.description') }}</nz-form-label>
            <nz-form-control>
              <textarea rows="4" nz-input formControlName="description"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row [nzGutter]="8">
        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{ tr('form.organizationId') }}</nz-form-label>
            <nz-form-control>
              <hx-org-select formControlName="organizationId"></hx-org-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label>{{ tr('form.storeId') }}</nz-form-label>
            <nz-form-control>
              <hx-store-select formControlName="storeId"></hx-store-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row [nzGutter]="8">
        <div nz-col>
          <nz-form-item>
            <nz-form-label nzRequired>{{ tr('form.status') }}</nz-form-label>
            <nz-form-control>
              <hx-enum-select formControlName="status" enumName="WebkassaCashboxStatus" [enumType]="WebkassaCashboxStatus"></hx-enum-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col>
          <nz-form-item>
            <nz-form-label>{{ tr('form.onlineCashboxId') }}</nz-form-label>
            <nz-form-control>
              <nz-select
                formControlName="onlineCashboxId"
                nzAllowClear nzShowSearch nzServerSearch [nzDropdownMatchSelectWidth]="false"
                (nzOnSearch)="onOnlineCashboxSearch($event)">
                <ng-container *ngIf="!isLoading.cashboxes">
                  <nz-option *ngFor="let op of cashboxes" [nzValue]="op.id" [nzLabel]="op.uniqueNumber + ' ' + op.name"></nz-option>
                </ng-container>
                <nz-option *ngIf="isLoading.cashboxes" nzDisabled nzCustomContent>
                  <ng-container *ngIf="!showSearchHint"><i nz-icon nzType="loading" class="loading-icon"></i> поиск...</ng-container>
                  <ng-container *ngIf="showSearchHint">введите уникальный код кассы для поиска</ng-container>
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

      <div nz-row [nzGutter]="8" class="cp_actions">
        <div nz-col>
          <nz-form-item>
            <nz-form-control>
              <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
                <i nz-icon nzType="save" nzTheme="outline"></i> {{ 'button.save' | transloco }}
              </button>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col>
          <nz-tag nzColor="success" *ngIf="form.pristine && model?.id">
            <i nz-icon nzType="check-circle"></i>
            <span>{{ 'form.saved' | transloco }}</span>
          </nz-tag>
        </div>
      </div>
    </form>
  </nz-skeleton>
</ng-container>
